var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 24.349c0 2.108.463 3.726 1.068 4.705.793 1.282 1.975 1.826 3.18 1.826 1.556 0 2.978-.386 5.72-4.178 2.196-3.039 4.784-7.304 6.525-9.978l2.948-4.53c2.049-3.147 4.42-6.645 7.138-9.016 2.22-1.935 4.613-3.01 7.022-3.01 4.045 0 7.898 2.344 10.847 6.74 3.227 4.815 4.793 10.88 4.793 17.138 0 3.72-.733 6.454-1.981 8.613-1.206 2.089-3.555 4.176-7.508 4.176V30.88c3.385 0 4.23-3.11 4.23-6.67 0-5.071-1.183-10.7-3.788-14.722-1.85-2.852-4.245-4.596-6.88-4.596-2.852 0-5.146 2.15-7.724 5.984-1.37 2.037-2.778 4.52-4.357 7.32l-1.74 3.081c-3.494 6.195-4.379 7.606-6.126 9.935-3.062 4.077-5.676 5.623-9.118 5.623-4.084 0-6.666-1.768-8.265-4.433-1.305-2.171-1.946-5.02-1.946-8.266l5.962.213Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.339 7.329C10.072 3.115 14.018.168 18.542.168c2.62 0 5.226.776 7.946 2.997 2.976 2.428 6.147 6.427 10.104 13.017l1.418 2.365c3.425 5.706 5.373 8.641 6.514 10.025 1.466 1.778 2.494 2.308 3.828 2.308 3.384 0 4.229-3.11 4.229-6.67l5.26-.165c0 3.72-.733 6.455-1.981 8.614-1.206 2.089-3.556 4.176-7.508 4.176-2.457 0-4.634-.534-7.042-2.805-1.85-1.743-4.014-4.84-5.678-7.623l-4.951-8.27c-2.484-4.15-4.763-7.245-6.082-8.647-1.419-1.507-3.242-3.327-6.153-3.327-2.355 0-4.356 1.653-6.03 4.181L7.34 7.33Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.447 6.163c-2.356 0-4.356 1.653-6.03 4.181C10.05 13.917 8.6 19.238 8.6 24.35c0 2.108.463 3.726 1.068 4.705l-5.084 3.348c-1.305-2.171-1.946-5.02-1.946-8.266 0-5.903 1.62-12.056 4.701-16.807C10.073 3.115 14.018.168 18.543.168l-.096 5.995Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 57.334v-9.697h1.756v8.225h4.271v1.472H10.15Zm7.552 0v-9.697h1.756v8.225h4.271v1.472h-6.027Zm9.569.147c-.46 0-.876-.082-1.245-.246a2.033 2.033 0 0 1-.872-.739c-.211-.325-.317-.726-.317-1.202 0-.41.076-.75.228-1.018a1.75 1.75 0 0 1 .62-.644 3.13 3.13 0 0 1 .885-.365 7.206 7.206 0 0 1 1.028-.184 40.53 40.53 0 0 0 1.037-.119c.265-.038.457-.094.577-.17.123-.08.185-.2.185-.365v-.028c0-.357-.106-.633-.317-.829-.212-.196-.516-.293-.914-.293-.42 0-.753.091-1 .274-.242.183-.406.4-.492.649l-1.6-.227c.126-.442.335-.812.625-1.108.29-.3.646-.524 1.065-.673a4.09 4.09 0 0 1 1.392-.227c.35 0 .7.041 1.047.123.347.082.664.218.951.407.288.187.518.44.692.763.177.322.265.724.265 1.207v4.867h-1.648v-.999h-.057c-.104.202-.25.392-.44.569a2.118 2.118 0 0 1-.705.421 2.85 2.85 0 0 1-.99.156Zm.445-1.26c.344 0 .642-.067.895-.203a1.5 1.5 0 0 0 .582-.55 1.4 1.4 0 0 0 .209-.742v-.857a.807.807 0 0 1-.275.123 3.903 3.903 0 0 1-.426.1c-.158.028-.314.053-.469.075l-.402.057a2.992 2.992 0 0 0-.687.17 1.14 1.14 0 0 0-.478.332.81.81 0 0 0-.175.54c0 .315.115.553.345.714.23.161.524.242.881.242Zm5.194-8.583h2.15l2.879 7.026h.113l2.879-7.026h2.15v9.697h-1.686v-6.663h-.09l-2.68 6.634h-1.26l-2.68-6.648h-.09v6.676H32.91v-9.697Zm13.329 9.697h-1.875l3.414-9.697h2.168l3.419 9.697H51.49l-2.59-7.709h-.076l-2.585 7.709Zm.061-3.803h5.114v1.411H46.3v-1.41Z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.348,
    x2: 52.358,
    y1: 22.629,
    y2: 24.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.276,
    x2: 11.276,
    y1: 26.852,
    y2: 12.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 15.185,
    x2: 48.783,
    y1: 54.136,
    y2: 57.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlama);
export default __webpack_public_path__ + "static/media/llama.03fb06a849965fcfb298b6c657ced8e5.svg";
export { ForwardRef as ReactComponent };